// services/childcare/programs.js
import { api } from "./utils";

// Get all programs, optionally filtered by child's date of birth
export const getPrograms = async (childDob = null) => {
  try {
    const params = childDob ? { child_dob: childDob } : {};
    const response = await api.get("/childcare/programs", { params });
    return response;
  } catch (error) {
    console.error("Error fetching programs:", error);
    throw error;
  }
};

// Get program by ID
export const getProgramById = async (id) => {
  try {
    const response = await api.get(`/childcare/programs/${id}`);
    return response;
  } catch (error) {
    console.error("Error fetching program:", error);
    throw error;
  }
};

// Create program
export const createProgram = async (programData) => {
  try {
    const response = await api.post("/childcare/programs", programData);
    return response;
  } catch (error) {
    console.error("Error creating program:", error);
    throw error;
  }
};

// Update program
export const updateProgram = async (id, programData) => {
  try {
    const response = await api.put(`/childcare/programs/${id}`, programData);
    return response;
  } catch (error) {
    console.error("Error updating program:", error);
    throw error;
  }
};

// Delete program
export const deleteProgram = async (id) => {
  try {
    const response = await api.delete(`/childcare/programs/${id}`);
    return response;
  } catch (error) {
    console.error("Error deleting program:", error);
    throw error;
  }
};

// Check if the facility has a complete Stripe Connect setup
export const getFacilityStripeStatus = async () => {
  try {
    const response = await api.get("/childcare/programs/stripe-status");
    return response;
  } catch (error) {
    console.error("Error fetching Stripe status:", error);
    throw error;
  }
};

// Get available staff for program.
// Pass scheduleParams (e.g. { monday_hours: "09:00-17:00" }) to filter out
// staff with overlapping assignments. Pass exclude_program_id when editing.
export const getAvailableStaff = async (params = {}) => {
  try {
    const response = await api.get("/childcare/programs/staff/available", {
      params,
    });
    return response;
  } catch (error) {
    console.error("Error fetching available staff:", error);
    throw error;
  }
};

/**
 * normalizeProgram — ensures flat field names the UI expects exist,
 * regardless of whether response comes from old or new schema.
 */
export const normalizeProgram = (p) => {
  const fees     = p.fees     && typeof p.fees     === 'object' ? p.fees     : {};
  const schedule = p.schedule && typeof p.schedule === 'object' ? p.schedule : {};
  return {
    ...p,
    program_name:    p.program_name    ?? p.name,
    intake_capacity: p.intake_capacity ?? p.capacity ?? 10,
    monthly_fee:     p.monthly_fee     ?? fees.monthly_fee  ?? 0,
    weekly_fee:      p.weekly_fee      ?? fees.weekly_fee   ?? 0,
    daily_rate:      p.daily_rate      ?? fees.daily_rate   ?? 0,
    monday_hours:    p.monday_hours    ?? schedule.monday   ?? '',
    tuesday_hours:   p.tuesday_hours   ?? schedule.tuesday  ?? '',
    wednesday_hours: p.wednesday_hours ?? schedule.wednesday ?? '',
    thursday_hours:  p.thursday_hours  ?? schedule.thursday ?? '',
    friday_hours:    p.friday_hours    ?? schedule.friday   ?? '',
    saturday_hours:  p.saturday_hours  ?? schedule.saturday ?? '',
    program_type:    p.program_type    ?? schedule.type     ?? '',
    enrolled_count:  p.total_enrolled  ?? p.enrolled_count  ?? 0,
  };
};
